import React, { useState, useEffect } from 'react';
import userService from '../services/userService';
import './UserActivityModal.css';

const UserActivityModal = ({ user, onClose }) => {
  const [activity, setActivity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('logins');

  useEffect(() => {
    loadUserActivity();
  }, [user.id]);

  const loadUserActivity = async () => {
    setLoading(true);
    try {
      const data = await userService.getUserActivity(user.id);
      setActivity(data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('es-VE', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getDeviceIcon = (deviceType) => {
    const icons = {
      'Desktop': '🖥️',
      'Mobile': '📱',
      'Tablet': '📱'
    };
    return icons[deviceType] || '💻';
  };

  const getActionIcon = (action) => {
    const icons = {
      'create': '➕',
      'update': '✏️',
      'import_create': '📤',
      'import_update': '🔄'
    };
    return icons[action] || '📝';
  };

  if (loading) {
    return (
      <div className="activity-overlay" data-testid="user-activity-modal">
        <div className="activity-content">
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Cargando actividad del usuario...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="activity-overlay" data-testid="user-activity-modal">
      <div className="activity-content">
        <div className="activity-header">
          <div className="user-info-header">
            <div className="user-avatar-large">{user.name?.charAt(0).toUpperCase()}</div>
            <div>
              <h2>{user.name}</h2>
              <p className="user-email">{user.email}</p>
              <span className="user-role-badge">{user.role}</span>
            </div>
          </div>
          <button onClick={onClose} className="modal-close" data-testid="close-activity-modal">✕</button>
        </div>

        {/* Stats Cards */}
        {activity && (
          <div className="stats-grid">
            <div className="stat-card">
              <span className="stat-icon">🔐</span>
              <div>
                <p className="stat-value">{activity.stats.total_logins}</p>
                <p className="stat-label">Logins Totales</p>
              </div>
            </div>
            <div className="stat-card">
              <span className="stat-icon">📝</span>
              <div>
                <p className="stat-value">{activity.stats.total_expediente_changes}</p>
                <p className="stat-label">Modificaciones</p>
              </div>
            </div>
            <div className="stat-card">
              <span className="stat-icon">🕐</span>
              <div>
                <p className="stat-value">{activity.stats.last_login ? formatDate(activity.stats.last_login) : 'Nunca'}</p>
                <p className="stat-label">Último Login</p>
              </div>
            </div>
          </div>
        )}

        {/* Tabs */}
        <div className="activity-tabs">
          <button
            onClick={() => setActiveTab('logins')}
            className={`tab-btn ${activeTab === 'logins' ? 'tab-btn-active' : ''}`}
            data-testid="tab-logins"
          >
            🔐 Historial de Logins
          </button>
          <button
            onClick={() => setActiveTab('changes')}
            className={`tab-btn ${activeTab === 'changes' ? 'tab-btn-active' : ''}`}
            data-testid="tab-changes"
          >
            📝 Modificaciones de Expedientes
          </button>
        </div>

        <div className="activity-content-area">
          {activeTab === 'logins' && (
            <div className="logins-list">
              {activity?.login_history?.length === 0 ? (
                <div className="empty-activity">
                  <p>No hay logins registrados</p>
                </div>
              ) : (
                activity?.login_history?.map((login, idx) => (
                  <div key={idx} className="login-item">
                    <div className="login-main">
                      <div className="device-info">
                        <span className="device-icon">{getDeviceIcon(login.device_type)}</span>
                        <div className="device-details">
                          <p className="device-name">{login.browser} en {login.os}</p>
                          <p className="device-type">{login.device_type}</p>
                        </div>
                      </div>
                      <div className="login-details">
                        <p className="login-time">{formatDate(login.login_at)}</p>
                        <p className="login-ip">IP: {login.ip_address}</p>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}

          {activeTab === 'changes' && (
            <div className="changes-list">
              {activity?.expediente_changes?.length === 0 ? (
                <div className="empty-activity">
                  <p>No hay modificaciones registradas</p>
                </div>
              ) : (
                activity?.expediente_changes?.map((change, idx) => (
                  <div key={idx} className="change-item">
                    <div className="change-header">
                      <span className="action-icon">{getActionIcon(change.action)}</span>
                      <div className="change-info">
                        <p className="change-action">{change.action}</p>
                        <p className="change-time">{formatDate(change.at)}</p>
                      </div>
                    </div>
                    <p className="expediente-id">Expediente: {change.entity_id}</p>
                    {change.diff && (
                      <div className="change-summary">
                        <p>Campos modificados: {Object.keys(change.diff).join(', ')}</p>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserActivityModal;